// extracted by mini-css-extract-plugin
module.exports = {"empty-box":"empty-box_empty-box__1Lyh7","empty-box-image":"empty-box_empty-box-image__2kKw4","empty-box-text":"empty-box_empty-box-text__3TVN3"};